var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.948,
    height: 14.871,
    viewBox: "0 0 24.948 14.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-2",
    transform: "translate(0 -98.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_333",
    "data-name": "Trac\\xE9 333",
    d: "M12.474,98.725c-4.767,0-9.089,2.608-12.279,6.844a.988.988,0,0,0,0,1.179c3.19,4.241,7.512,6.849,12.279,6.849s9.089-2.608,12.279-6.844a.988.988,0,0,0,0-1.179C21.563,101.333,17.241,98.725,12.474,98.725Zm.342,12.672A5.247,5.247,0,1,1,17.71,106.5,5.25,5.25,0,0,1,12.816,111.4Zm-.158-2.419a2.825,2.825,0,1,1,2.638-2.638A2.821,2.821,0,0,1,12.658,108.978Z",
    transform: "translate(0 0)",
    fill: "#afafaf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.4dc527ca0fa4600bb1a7cdb10c60b901.svg";
export { ForwardRef as ReactComponent };